import { createContext, useContext, ReactNode, FC } from 'react';
import { useContentful } from 'reactQuery/queries';
import { LoadingBar } from 'components/core';

export type i18nStore = {
  [key: string]: string;
};

const I18nContext = createContext<i18nStore>({});

export const I18nProvider: FC<{
  children: ReactNode;
  locale?: string;
}> = ({ children, locale }) => {
  const {
    data: contentfulData = { i18n: {} },
    isLoading,
    isIdle,
  } = useContentful(locale);
  if (isLoading || isIdle) {
    return <LoadingBar />;
  }

  return (
    <I18nContext.Provider value={contentfulData.i18n}>
      {children}
    </I18nContext.Provider>
  );
};

export function useI18n() {
  const i18nData = useContext(I18nContext);
  return i18nData;
}
